const Confetti = function(context) {
  const COLORS = [
    [235, 90, 70],
    [97, 189, 79],
    [242, 214, 0],
    [0, 121, 191],
    [195, 119, 224]
  ];

  this.init = (context) => {
    this.context = context;
    this.style = COLORS[~~this.range(0, 5)];
    this.rgb =
      "rgba(" + this.style[0] + "," + this.style[1] + "," + this.style[2];
    this.r = ~~this.range(2, 6);
    this.r2 = 2 * this.r;
    this.replace();
  };

  this.replace = () => {
    this.opacity = 0;
    this.dop = 0.03 * this.range(1, 4);
    this.x = this.range(-this.r2, window.w - this.r2);
    this.y = this.range(-20, window.h - this.r2);
    this.xmax = window.w - this.r;
    this.ymax = window.h - this.r;
    this.vx = this.range(0, 2) + 8 * window.xpos - 5;
    return (this.vy = 0.7 * this.r + this.range(-1, 1));
  };

  this.draw = () => {
    let a;
    this.x += this.vx;
    this.y += this.vy;
    this.opacity += this.dop;
    1 < this.opacity && ((this.opacity = 1), (this.dop *= -1));
    (0 > this.opacity || this.y > this.ymax) && this.replace();
    if (!(0 < (a = this.x) && a < this.xmax))
      this.x = (this.x + this.xmax) % this.xmax;
    
    this.drawCircle(
      ~~this.x,
      ~~this.y,
      this.r,
      this.rgb + "," + this.opacity + ")"
    );
    this.drawCircle3(
      0.5 * ~~this.x,
      ~~this.y,
      this.r,
      this.rgb + "," + this.opacity + ")"
    );
    return this.drawCircle2(
      1.5 * ~~this.x,
      1.5 * ~~this.y,
      this.r,
      this.rgb + "," + this.opacity + ")"
    );
  };

  this.range = (a, b) => {
    return (b - a) * Math.random() + a;
  };

  this.drawCircle = (a, b, c, d) => {
    this.context.beginPath();
    this.context.moveTo(a, b);
    this.context.bezierCurveTo(a - 17, b + 14, a + 13, b + 5, a - 5, b + 22);
    this.context.lineWidth = 2;
    this.context.strokeStyle = d;
    return this.context.stroke();
  };

  this.drawCircle2 = (a, b, c, d) => {
    this.context.beginPath();
    this.context.moveTo(a, b);
    this.context.lineTo(a + 6, b + 9);
    this.context.lineTo(a + 12, b);
    this.context.lineTo(a + 6, b - 9);
    this.context.closePath();
    this.context.fillStyle = d;
    return this.context.fill();
  };

  this.drawCircle3 = (a, b, c, d) => {
    this.context.beginPath();
    this.context.moveTo(a, b);
    this.context.lineTo(a + 5, b + 5);
    this.context.lineTo(a + 10, b);
    this.context.lineTo(a + 5, b - 5);
    this.context.closePath();
    this.context.fillStyle = d;
    return this.context.fill();
  };

  this.init(context);
};

const ConfettiEffect = function() {
  let canvas = null;
  let context = null;
  let confetti = [];
  const NUM_CONFETTI = 40;

  this.init = () => {
    canvas = document.getElementById("confeti");
    context = canvas.getContext("2d");

    window.w = 0;
    window.h = 0;
    window.xpos = 0.9;

    window.resizeWindow = function() {
      window.w = canvas.width = window.innerWidth;
      return window.h = canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", window.resizeWindow, !1);
    
    setTimeout(window.resizeWindow, 100);

    window.onload = function() {
      return setTimeout(window.resizeWindow, 0);
    };

    document.onmousemove = function(a) {
      return (window.xpos = a.pageX / window.w);
    };

    window.requestAnimationFrame = (function() {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function(a) {
          return window.setTimeout(a, 5);
        }
      );
    })();

    confetti = this.createConfetti();
    this.step();
  };

  this.createConfetti = () => {
    let a, b, c;
    c = [];
    // eslint-disable-next-line no-unused-vars
    let i = (a = 1);
    for (
      b = NUM_CONFETTI;
      1 <= b ? a <= b : a >= b;
      i = 1 <= b ? ++a : --a
    )
      c.push(new Confetti(context));
    return c;
  };

  this.step = () => {
    let a, b, c, d;
    window.requestAnimationFrame(this.step);
    context.clearRect(0, 0, window.w, window.h);
    d = [];
    b = 0;
    for (c = confetti.length; b < c; b++) {
      a = confetti[b];
      d.push(a.draw());
    }

    return d;
  };

  this.init();
};

export default ConfettiEffect;
